import React, { Component } from 'react';
import { connect } from 'react-redux';
import dayjs from 'dayjs';

import * as constants from '../constants';
import {
    loadWorkflowLogbook
} from '../actions';

import core from '../../core';
import uistate from '../../uistate';
import common from '../../../common';

const { GenericTable } = core;


class LogbookGrid extends Component {


    label = (key) => {
        return common.getLabel(this.props.labels, constants.NAME, 'LogbookGrid', key);
    }

    UNSAFE_componentWillMount() {
        this.props.loadWorkflowLogbook(this.props.workflowInstanceId);
    }

    render() {
        const columns = [{
            title: this.label('UPN'),
            dataIndex: 'upn',
            key: 'upn',
            sorter: (a, b) => ('' + a.upn).localeCompare(b.upn),
        }, {
            title: this.label('Message'),
            dataIndex: 'message',
            key: 'message',
            sorter: (a, b) => ('' + a.message).localeCompare(b.message),
        }, {
            title: this.label('CompletedOn'),
            dataIndex: 'completedOn',
            key: 'completedOn',
            sorter: (a, b) => {
                if (dayjs(a.completedOn).isBefore(dayjs(b.completedOn))) {
                    return -1;
                }
                return 1;
            },
            render: (text, record) => (
                <span>
                    {dayjs(record.completedOn).format('DD-MM-YYYY HH:mm:ss')}
                </span>
            )
        }];

        return (
            <div className='logbook'>
                <GenericTable aligntop multiline columns={columns} data={this.props.logbookitems} keyfield='idLogbook' itemName={this.label('LogbookItem')} pagesize={20} />
            </div>
        );
    }
}
function mapStateToProps(state) {
    return {
        logbookitems: state[constants.NAME].logbookitems,
        labels: uistate.selectors.uiLabels(state),
    };
}

export default connect(mapStateToProps,
    {
        loadWorkflowLogbook
    })(LogbookGrid);